import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const vuetifyOptions = {
  theme: {
    dark: false,
    // default: 'dark',
    themes: {
      dark: {
        primary: '#1EB980',
        secondary: '#045D56',
        tertiary: '#FF6859',
        quaternary: '#FFCF44',
        quinary: '#B15DFF',
        senary: '#72DEFF',
      },
      // light: {
      //   primary: '#6200EA',
      //   secondary: '#03DAC6',
      //   accent: '#FF5722',
      //   error: '#B00020',
      //   info: '#0288D1',
      //   success: '#388E3C',
      //   warning: '#FBC02D',
      //   background: '#FFFFFF',
      //   surface: '#F5F5F5',
      //   text: '#212121',
      // },
      // dark: {
      //   primary: '#BB86FC',
      //   secondary: '#03DAC6',
      //   accent: '#FF8A50',
      //   error: '#CF6679',
      //   info: '#4FC3F7',
      //   success: '#66BB6A',
      //   warning: '#FFEB3B',
      //   background: '#121212',
      //   surface: '#1E1E1E',
      //   text: '#E0E0E0',
      // },
      // light: {
      //   // dark: false,
      //   primary: '#1976D2',
      //   secondary: '#424242',
      //   accent: '#82B1FF',
      //   error: '#FF5252',
      //   info: '#2196F3',
      //   success: '#4CAF50',
      //   warning: '#FB8C00',
      // },
      // dark: {
      //   // dark: true,
      //   primary: '#2196F3',
      //   secondary: '#424242',
      //   accent: '#FF4081',
      //   error: '#FF5252',
      //   info: '#2196F3',
      //   success: '#4CAF50',
      //   warning: '#FB8C00',
      // },
    },


  },
  icons: {
    iconfont: 'mdi',
  },
  customProperties: true,
};

export default new Vuetify(vuetifyOptions);
